module.exports = __webpack_public_path__ + "img/warningDodIcon.1c774c3d.svg";